<template>
  <header>
    <section class="home" v-if="state === 'home'">
      <img class="logo" src="../../assets/logo_group.svg" alt="logo" >
      <h5>Crypto Wallet</h5>
    </section>
    <section class="account" v-if="state === 'account'">
      <a href="/">
        <img class="logo" src="../../assets/logo_group.svg" alt="logo">
      </a>
      <h5>Account</h5>
    </section>
    <section class="search" v-if="state === 'search'">
      <button class="btn btn-link" @click="goToAccount">
        <i class="icon icon-back" aria-hidden="true"></i>
      </button>
      <h5>Search</h5>
    </section>
    <section class="add" v-if="state === 'add'">
      <button class="btn btn-link" @click="goToSearch">
        <i class="icon icon-back" aria-hidden="true"></i>
      </button>
      <h5>Add new coin</h5>
    </section>
    <section class="edit" v-if="state === 'edit'">
      <button class="btn btn-link" @click="goToCoin">
        <i class="icon icon-back" aria-hidden="true"></i>
      </button>
      <h5>Edit purchase</h5>
    </section>
    <section class="coin" v-if="state === 'coin'">
      <button class="btn btn-link" @click="goToAccount">
        <i class="icon icon-back" aria-hidden="true"></i>
      </button>
      <h5>Coin Details</h5>
    </section>
    <section class="fourOhfour" v-if="state === 'fourOhfour'">
      <button class="btn btn-link" @click="goToAccount">
        <i class="icon icon-back" aria-hidden="true"></i>
      </button>
      <h5>Oops</h5>
    </section>
  </header>
</template>

<script>
import Router from '@/router';
import Service from '@/service';

export default {
  name: 'Header',
  props: [
    'state',
  ],
  methods: {
    goToAccount() {
      Router.push({ name: 'Account' });
    },
    goToSearch() {
      Router.push({ name: 'Search' });
    },
    goToCoin() {
      const key = this.$route.params.purchaseId || false;
      const coin = Service.getPurchaseByKey(key);

      if (key && coin && coin.code) {
        Router.push({ name: 'Coin', params: { code: coin.code.toLowerCase() } });
      } else {
        // if for any reason can't find purchase, then just go back to account
        Router.push({ name: 'Account' });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
header {
  height: 3rem;
  background: #424242;
  color: #EEEEEE;
  box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);

  section {
    height: inherit;

    img {
      height: 3rem;
      padding: 0.625rem;
    }

    h5 {
      top: 1rem;
      margin-bottom: 0;
    }
  }

  section.home {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  section.account {
    text-align: center;

    a {
      left: 0;
      position: absolute;
    }

    h5 {
      position: relative;
      margin: 0 60px;
    }
  }

  section.search, section.add, section.edit, section.coin, section.fourOhfour {
    text-align: center;

    button {
      position: absolute;
      left: 0;
      height: inherit;
      font-size: 1.2rem;
      padding: 0.4rem 0.625rem;
      color: #EEEEEE;

      &:hover {
        color: white;
      }
    }

    h5 {
      position: relative;
      margin: 0 60px;
    }
  }

}
</style>




// WEBPACK FOOTER //
// src/components/header/Header.vue